// extracted by mini-css-extract-plugin
export default {"container":"styles_container__06OkM","label":"styles_label__clnDu"};